import { createFileRoute } from "@tanstack/react-router";
import DepressionInWomen from "@/pages/articles/DepressionInWomen";
export const Route = createFileRoute("/depression-in-women")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Depression In Women | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Depression in women has unique causes and treatment paths. Learn about TMS, SAINT TMS, and supportive care for women in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:title",
          content: "Depression In Women | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Depression in women has unique causes and treatment paths. Learn about TMS, SAINT TMS, and supportive care for women in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/depression-in-women",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/depression-in-women",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <DepressionInWomen />;
}
